import { Component, OnInit,ViewEncapsulation, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MatDialogConfig } from '@angular/material';
import { NotificationServices} from '../../../appauth/notification/notificatio.services';
import { Recepcionistas } from '../modelo-recepcionista/recepcionistas.model';
import { RecepcionistasServices } from '../modelo-recepcionista/servicios-recepcionistas.services';
import { InsertarRecepcionistaModalComponent } from '../modales-recepcionista/insertar/insertarrecepcionistamodal.component';
import { EditarRecepcionistaModalComponent } from '../modales-recepcionista/editar/editarrecepcionistamodal.component';
import { Globals } from 'app/global/global.model';
import { FotoRecepcionistasComponent } from 'app/appmantenimiento/reparar-fotorecepcionistas/foto/fotorecepcionista.compente';

@Component({
	selector: 'ms-recepcionistavista',
	templateUrl:'./recepcionistavista.component.html',
	styleUrls: ['./recepcionistavista.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class RecepcionistaListaComponent implements OnInit {
	rows = [];
	temp = [];

	public imgUrlRecepcionistas:string;

	iconItems = [{
		text: 'Nuevo',
		icon: 'add'
	},{
		text: 'Refrescar',
		icon: 'refresh'
	}];

	config: MatDialogConfig = {
		disableClose: false,
		width: '50%',
		height: '60%',
		position: {
			top: '5%',
			bottom: '',
			left: '',
			right: ''
		},
		data: { datasend: null }
	};

	configFoto: MatDialogConfig = {
		disableClose: false,
		width: '35%',
		height: '30%',
		position: {
			top: '5%',
			bottom: '',
			left: '',
			right: ''
		},
		data: { datasend: null }
	};

	select(text: string) {
		if(text=='Refrescar'){
			this.listaRecepcionistas();
		}else if(text=='Nuevo'){
			this.openRecepcionista();
		}
	}

	constructor(private serviciosRecepcionistas:RecepcionistasServices,
		public dialog: MatDialog,
		public mensajes:NotificationServices,
	){}

	ngOnInit(){
		this.imgUrlRecepcionistas=Globals.BASE_URL_API_REST;
		this.listaRecepcionistas();
	}

	listaRecepcionistas(){
		this.serviciosRecepcionistas.obtenerDatosRecepcionistas().subscribe((data:any)=>{
			this.temp = [...data.recepcionistas];
			this.rows=data.recepcionistas;
		});
	}

	openRecepcionista() {
		let dialogRef = this.dialog.open(InsertarRecepcionistaModalComponent, this.config);
		dialogRef.afterClosed().subscribe(result => {
			if(result==1)
				this.listaRecepcionistas();
		});
	}

	updateFilter(event) {
		const val = event.target.value.toLowerCase();
		const temp = this.temp.filter((d)=> {
			return d.nombre.toLowerCase().indexOf(val) !== -1 || d.apellido.toLowerCase().indexOf(val) !== -1 || d.cedula.toLowerCase().indexOf(val) !== -1 || !val;
		});
		this.rows = temp;
	}

	deleteRecepcionista(dataRecepcionista:any){
		let data={'val':dataRecepcionista.nombre,'msg':'Eliminar Recepcionista'};
		this.mensajes.msgEliminarConfir(data).then((datas)=>{
			if(datas){
				this.serviciosRecepcionistas.eliminarRecepcionistas(dataRecepcionista.id).subscribe((smsdata:any)=>{
					if(smsdata.estado){
						this.mensajes.setNotification(smsdata).then((datas)=>{
							if(datas){
								this.listaRecepcionistas();
							}
						});
					}else{
						this.mensajes.setNotification(smsdata);
					}
				});
			}
		});
	}

	editRecepcionista(data:any) {
		this.config.data=data;
		let dialogRef = this.dialog.open(EditarRecepcionistaModalComponent, this.config);
		dialogRef.afterClosed().subscribe(result => {
			if(result==1)
				this.listaRecepcionistas();
		});
	}

	editFotoRecepcionistas(data:any){
		this.configFoto.data=data;
		let dialogRef = this.dialog.open(FotoRecepcionistasComponent, this.configFoto);
		dialogRef.afterClosed().subscribe(result => {
			if(result==1)
				this.listaRecepcionistas();
		});
	}

}